import { memo } from 'react';
import { useSelector } from 'react-redux';

import { useShortIdContext } from '@air/provider-short-id';

import { BoardStats } from '~/components/v2/components/board/shared/BoardStats';
import { usePublicBoardStats } from '~/components/v2/hooks/queries/usePublicBoardsStats';
import { formatBoardStats } from '~/components/v2/utils/boards/formatBoardStats';
import { useIsFlattenedView } from '~/hooks/search/useIsFlattenedView';
import { centralizedBoardIdSelector } from '~/store/centralizedBoard/selectors';

export const PublicBoardStats = memo(() => {
  const boardId = useSelector(centralizedBoardIdSelector);
  const { presentationSettings, shortId } = useShortIdContext();
  const isExpandNestedDisabled = presentationSettings?.lockedControls?.expandNested === true;
  const { isFlattenedView } = useIsFlattenedView({ disabled: isExpandNestedDisabled });
  const { data: boardStats } = usePublicBoardStats({
    boardId: boardId || '',
    shortId,
    includeDescendants: isFlattenedView,
  });

  if (!boardStats) {
    return null;
  }

  return <BoardStats data-testid="PUBLIC_BOARD_STATS">{formatBoardStats(boardStats).join(' · ')}</BoardStats>;
});

PublicBoardStats.displayName = 'PublicBoardStats';
